import styled from "@emotion/styled";

export const Wrapper = styled.div`
  margin-bottom: ${p => p.theme.space[6]}px;
`;

export const SubTitle = styled.p`
  margin: ${p => p.theme.space[0]}px;
  font-weight: ${p => p.theme.fontWeight.semiBold};
  font-size: 22px;
  line-height: 1.25;
  color: ${p => p.theme.colors.black};

  @media screen and (min-width: ${p => p.theme.screenSizes.mdMax}) {
    font-weight: ${p => p.theme.fontWeight.medium};
    font-size: 28px;
    line-height: normal;
  }
`;

export const SubTitleSpan = styled.span`
  color: ${prop => prop.theme.colors.error.main};
`;

export const DescTitle = styled.p`
  margin-top: ${p => p.theme.space[3]}px;
  margin-bottom: ${p => p.theme.space[0]}px;
  line-height: 1.625;

  color: ${p => p.theme.colors.secondary.gray};

  @media screen and (min-width: ${p => p.theme.screenSizes.mdMax}) {
    font-size: 18px;
    line-height: 1.78;
  }
`;
